<div class="emails-type-list">
  <ng-container *ngIf="!loadingSpinner">
    <div class="email-type" *ngFor="let condWithTitle of columnConditionBlock let i = index">
      <div class="email-type-title">
        {{condWithTitle.title}}
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <button mat-button class="email-changer-button"
                  *ngFor="let cond of condWithTitle.conditions; let j = index"
                  (click)="editColumn(cond, i, j)">
            {{cond.name}}
          </button>
        </div>
      </div>
    </div>

    <div class="email-type">
      <div class="email-type-title">
        Presets
        <button mat-icon-button (click)="addPreset()">
          <mat-icon>add</mat-icon>
        </button>
      </div>
      <div class="email-type-body">
        <div class="email-change-buttons">
          <div class="preset-item" *ngFor="let preset of presets">
            <button mat-button class="email-changer-button" (click)="editPreset(preset)">
              {{preset.title}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <div class="loading-body" *ngIf="loadingSpinner">
    <lib-progress-spinner></lib-progress-spinner>
  </div>

</div>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>
